var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module-app"},[_c('UiGallery'),_c('ConsultationModal'),_c('BookingOnlineModal'),_c('StateDutyModal'),_c('RouterView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }